import { render, staticRenderFns } from "./VehicleWideScreen.vue?vue&type=template&id=0bbf00b5&scoped=true&"
import script from "./VehicleWideScreen.vue?vue&type=script&lang=js&"
export * from "./VehicleWideScreen.vue?vue&type=script&lang=js&"
import style0 from "./VehicleWideScreen.vue?vue&type=style&index=0&id=0bbf00b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf00b5",
  null
  
)

export default component.exports